module.exports = __webpack_public_path__ + "static/media/Filter_Dropdown.6d1b265c.svg";